import React, { createContext, useContext, useEffect, useState } from 'react'
import { productsApi, categoriesApi } from '../restaurant.api'

const ProductsContext = createContext({
  loading: true,
  products: [],
  categories: [],
  search: '',
  setSearch: () => {},
  refresh: () => {},
})

export const useProducts = () => useContext(ProductsContext)

export const ProductsProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [products, setProducts] = useState([])
  const [categories, setCategories] = useState([])
  const [search, setSearch] = useState('')

  const load = async () => {
    setLoading(true)
    const [productsRes, categoriesRes] = await Promise.all([
      productsApi.list({ limit: 1000 }),
      categoriesApi.list(),
    ])
    if (productsRes.response) setProducts(productsRes.response.data || [])
    if (categoriesRes.response) setCategories(categoriesRes.response.data || [])
    setLoading(false)
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const filtered = products.filter((product) =>
    (product.name || '').toLowerCase().includes(search.toLowerCase())
  )

  return (
    <ProductsContext.Provider
      value={{
        loading,
        products: filtered,
        categories,
        search,
        setSearch,
        refresh: load,
      }}
    >
      {children}
    </ProductsContext.Provider>
  )
}
